module.exports = __webpack_public_path__ + "img/login_illustration.fec85ff0.svg";